"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseInputValue = exports.parseDefaultDisplayValue = exports.formatCentsToEditableValue = exports.formatDisplayValue = exports.sanitizeAmountInput = exports.unformatDisplayValue = exports.stripGroupSeparators = void 0;
const currency_1 = require("../../helpers/currency");
const numbers_1 = require("./numbers");
const stripGroupSeparators = (value, locale) => {
    const withoutSpaces = value.replace(/[\s\u00A0\u202F]/g, "");
    return (0, numbers_1.getDecimalSeparator)(locale) === ","
        ? withoutSpaces.replace(/\.(?=\d{3})/g, "")
        : withoutSpaces.replace(/,(?=\d{3})/g, "");
};
exports.stripGroupSeparators = stripGroupSeparators;
const unformatDisplayValue = (value, locale) => (0, exports.stripGroupSeparators)(value, locale).replace(",", ".");
exports.unformatDisplayValue = unformatDisplayValue;
const sanitizeAmountInput = (value) => value.replace(/[^\d.,\s\u00A0\u202F]/g, "");
exports.sanitizeAmountInput = sanitizeAmountInput;
const formatDisplayValue = (value, locale) => {
    const numericValue = parseFloat((0, exports.unformatDisplayValue)(value, locale));
    if (!isFinite(numericValue)) {
        return value;
    }
    return (0, numbers_1.formatAmountWithThousandsSeparators)(numericValue, locale);
};
exports.formatDisplayValue = formatDisplayValue;
const formatCentsToEditableValue = (cents, locale) => (0, currency_1.getDollarValue)(cents).toString().replace(".", (0, numbers_1.getDecimalSeparator)(locale));
exports.formatCentsToEditableValue = formatCentsToEditableValue;
const parseDefaultDisplayValue = (value, locale) => {
    if (value === 0) {
        return "0";
    }
    if (value) {
        return (0, exports.formatDisplayValue)((0, currency_1.getDollarValue)(value).toString(), locale);
    }
    return "";
};
exports.parseDefaultDisplayValue = parseDefaultDisplayValue;
const parseInputValue = (value, locale) => {
    // Check if value is too large to be safely handled
    const MAX_SAFE_AMOUNT = 10000000000; // $999,999,999,999.99
    const numericValue = parseFloat((0, exports.unformatDisplayValue)(value, locale));
    if (numericValue > MAX_SAFE_AMOUNT) {
        return MAX_SAFE_AMOUNT;
    }
    const parsedValue = (0, currency_1.getCentsValue)(numericValue);
    return isNaN(parsedValue) || parsedValue === null ? null : Math.round(parsedValue);
};
exports.parseInputValue = parseInputValue;
